import React, { useState } from "react";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import { Formik } from "formik";

import Button from "../../../components/ButtonUI";
import Input from "../../../components/Input";
import makeToast from "../../../components/Snackbar";
import ConfirmModal from "./ConfirmModalEdit";
import ConfirmModalRedirection from "./ConfirmModalRedirection";
import validationSchema from "./validateSchema";
import {
  addClient,
  updateClient,
} from "../../../api/client";
import { ReactComponent as Close } from "../../../assets/icons/icon-close.svg";
import fr from "date-fns/locale/fr";
import "./styles.scss";
import { ConfirmModalExistClient } from "./ConfirmModalExistClient";

const intialValueForm = {
  name: "",
};

registerLocale("fr", fr);
setDefaultLocale("fr");
interface IProps {
  openModal: Boolean;
  setOpenModal: Function;
  message?: String;
  type?: String;
  url?: string;
  setClientAdded: boolean | any;
  setSelectedClient: Function;
  setClientData: Function;
  setOpenModalInfoClient: Function;
  editMode: boolean;
  clientData: {
    _id: string;
    name: string;
  };
  setRefreshClient: Function
}

const AddClient: React.FC<IProps> = ({
  openModal,
  setOpenModal,
  setClientAdded,
  setSelectedClient,
  setClientData,
  editMode,
  setOpenModalInfoClient,
  clientData,setRefreshClient
}) => {
  const [confirmEditModal, setConfirmEditModal] = useState(false);
  const [intialVal, setIntialVal] = useState(editMode ? clientData : intialValueForm);
  const [response, setResponse] = useState("");

  const handleAddClient = async (values) => {
  try {
    const { name } = values;

    if (name === "") {
      makeToast("error", "Veuillez remplir les champs obligatoires");
      return;
    }

    const response = await addClient(values);

    // The new client is here:
    const newClient = response?.data?.response;

    if (!newClient) {
      makeToast("error", "Impossible de récupérer le client créé");
      return;
    }

    setClientAdded(true);
    setOpenModal(!openModal);
    setSelectedClient(newClient._id);
    setClientData(newClient);
    setRefreshClient((prev) => !prev);
    makeToast("success", "Client créé avec succès.");
    
  } catch (error) {
    console.log(error);
    makeToast("error", "Erreur lors de la création du client");
  }
};
  const handleEditClient = async (values) => {
    try {
      const { name } = values;

      if ( name === "" ) {
        makeToast("error", "Veuillez remplir les champs obligatoires");
      } else {
        const response = await updateClient(
          clientData._id,
          values
        );
        
        if (response.updated_client) {
          setClientAdded(true);
          setOpenModal(!openModal);
          setSelectedClient(response.updated_client._id);
          setClientData(response.patient);
          setRefreshClient((prev) => !prev);
          makeToast(
            "success",
            "Mise à jour des données du client effectuée avec succès."
          );
          setOpenModalInfoClient(true);
        }
      }
    } catch (error) {
      makeToast("error", "Erreur");
      console.log(error);
    }
  };
  return (
    <div className="fixed inset-0 z-50 outline-none focus:outline-none overflow-x-hidden overflow-y-auto bg-opacity-modal flexCenter">
      <div className="absolute  inset-y-0 right-0  form-add-patient  z-40 transition ease-in duration-700 patient-modal-info">
        <Button
          status="icon-secondary"
          className="absolute top-1 right-1"
          onClick={() => setOpenModal(!openModal)}
        >
          <Close />
        </Button>
        <h1 className="title flexCenter text-center">
          {editMode ? "Édition de la fiche client" : "Nouveau client"}
        </h1>
        <div className="form-container flexCenter">
          <Formik
            initialValues={intialVal}
            onSubmit={async (values) => {
              try {
                console.log("Submited");
                //handleAddClient(values)
              } catch (error) {
                console.log("error", error);
              }
            }}
            validationSchema={validationSchema}
          >
            {(props) => {
              const {
                values,
                errors,
                handleChange,
                handleBlur,
                handleSubmit,
                touched,
              } = props;

              return (
                <>
                  <form
                    onSubmit={handleSubmit}
                    className="form-login flexCenter flex-col fixingColor"
                  >
                    <div className="relative">
                      <Input
                        id="name"
                        placeholder="Nom du client"
                        type="text"
                        error={touched.name ? errors.name : undefined}
                        value={values.name}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className="custom-Input mb-2.5"
                        inlineLabel={false}
                        onfocus={true}
                        icon="user"
                        iconColor="white"
                        isIcon={true}
                      />
                      {values.name === "" && (
                        <span className="absolute top-0 bottom-0 right-0">
                          <span className="flex items-center w-max h-4 subpixel-antialiased px-1 py-1 text-xs  leading-none text-gray-400  bg-gray-100 rounded">
                            ✯
                          </span>
                        </span>
                      )}
                    </div>
                   

                    <div className="flex flex-row gap-x-8 mb-12"></div>

                    <div className="flexCenter">
                      <Button
                        status="primary"
                        className="btn mb-2.5"
                        onClick={() =>
                          editMode
                            ? setConfirmEditModal(true)
                            : handleAddClient(values)
                        }
                      >
                        Enregistrer
                      </Button>
                    </div>
                    
                    {editMode && confirmEditModal && (
                      <ConfirmModal
                        action={() => handleEditClient(values)}
                        setOpenModal={setConfirmEditModal}
                      />
                    )}
                  </form>
                </>
              );
            }}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default AddClient;
